export default "__VITE_ASSET__BkmTqRny__"